module.exports = __webpack_public_path__ + "img/warning.04dce954.svg";